import '../../base/outline-grid/outline-column/outline-column';
import '../../base/outline-grid/outline-grid';
import '../ghs-button/ghs-button';
import './ghs-location-detail-left-column/ghs-location-detail-left-column';
import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './ghs-location-detail.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The GhsLocationDetail component
 * @element ghs-location-detail
 */
@customElement('ghs-location-detail')
export class GhsLocationDetail extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, false);

  @state() hasMapSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasMapSlot = this.slots.test('map-image');
  }

  /**
   * Document property here
   */
  @property({ type: String, attribute: 'property-var' })
  propertyVar: string;

  render(): TemplateResult {
    return html`
      <div class="location-detail__wrapper">
        <slot name="location-detail-left-column"></slot>
        ${this.hasMapSlot
          ? html`<div class="location-detail__map--image">
              <slot name="map-image"></slot>
            </div>`
          : nothing}
      </div>
    `;
  }
}
